export function transformPatches(patches: any[]): any[] {
  return patches.map(patch => {
    const pathParts = patch.path.split('/');

    if (pathParts.length > 2) {
      const objectPath = '/' + pathParts[1];
      const propertyName = pathParts[2];

      return {
        value: {
          [propertyName]: patch.value
        },
        path: objectPath,
        op: "replace"
      };
    }

    return patch;
  });
}